import script from "./orderDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./orderDetail.vue?vue&type=script&setup=true&lang=js"

import "./orderDetail.vue?vue&type=style&index=0&id=56119fdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56119fdc"]])

export default __exports__